import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';
import { GameServices } from '../../game-services';

export class DebugControlsViewModel {
  protected readonly gameServices: GameServices;

  constructor(gameServices: GameServices) {
    this.gameServices = gameServices;
  }

  public calculateScaleFactor(gameSizeMetrics: GameSizeMetrics): {
    totalWidth: number;
    scaleFactor: number;
  } {
    return this.gameServices.gameMetricsService.calculateBoardScaling(gameSizeMetrics);
  }

  public undoCommand() {
    this.gameServices.gameRunnerService.undo();
  }

  public showHints() {
    this.gameServices.gameRunnerService.hint();
  }

  public dealNewDeck() {
    this.gameServices.gameRunnerService.createLocalGame();
  }
}
